/* ============================================================================
   Farmkart Free-Shipping Progress Bar
   Snippet : snippets/free-ship-progress.liquid
   Styles  : assets/free-ship-progress.css

   Finds every [data-fk-free-ship-bar] element on the page and keeps all of
   them in sync. Updates on:
     1. DOMContentLoaded  — reads initial paise from data attribute (no fetch)
     2. cart:updated      — custom event fired after any AJAX cart mutation
     3. visibilitychange  — catches carts updated in another tab
   ============================================================================ */
(function () {
  'use strict';

  var FREE_SHIP_THRESHOLD_PAISE = 149900; // ₹1499

  function updateBars(totalPaise) {
    var bars = document.querySelectorAll('[data-fk-free-ship-bar]');
    if (!bars || !bars.length) return;

    var pct  = Math.min(100, Math.round((totalPaise / FREE_SHIP_THRESHOLD_PAISE) * 100));
    var met  = totalPaise >= FREE_SHIP_THRESHOLD_PAISE;
    var diff = Math.ceil((FREE_SHIP_THRESHOLD_PAISE - totalPaise) / 100);

    for (var i = 0; i < bars.length; i++) {
      var bar  = bars[i];
      var fill = bar.querySelector('.fk-free-ship__fill');
      var msg  = bar.querySelector('.fk-free-ship__msg');

      bar.setAttribute('data-fk-free-ship', met ? 'met' : 'below');

      if (fill) fill.style.width = pct + '%';

      if (msg) {
        // DS V2 §05: Material Symbols Rounded check (FILL 1) replaces the glyph
        if (met) {
          msg.innerHTML = '<svg class="fk-icon fk-inline-icon" width="16" height="16" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true" focusable="false"><path d="m382-354 339-339q12-12 28-12t28 12q12 12 12 28.5T777-636L410-268q-12 12-28 12t-28-12L182-440q-12-12-11.5-28.5T183-497q12-12 28.5-12t28.5 12l142 143Z"/></svg> Free shipping unlocked!';
        } else {
          msg.textContent = 'Add ₹' + Number(diff).toLocaleString('en-IN') + ' more for FREE shipping';
        }
      }
    }
  }

  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBars(cart.total_price || 0); })
      .catch(function () { /* keep current state on network error */ });
  }

  function initFromDOM() {
    var first = document.querySelector('[data-fk-free-ship-bar]');
    if (!first) return;
    var initialPaise = parseInt(first.getAttribute('data-cart-total-paise') || '0', 10);
    updateBars(initialPaise);
  }

  // ── Boot ───────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromDOM);
  } else {
    initFromDOM();
  }

  // Re-render after any cart AJAX mutation (cart drawer, ATC, etc.)
  document.addEventListener('cart:updated', fetchAndUpdate);

  // Catch updates made in other tabs / windows
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') fetchAndUpdate();
  });
}());
